import React from 'react';
import routes from '../../../controller/Routes';
import { isAdminLoggedIn } from '../../../controller/localStroageHandler';
import { Navigate } from 'react-router-dom';
import Dashboard from '../component/Dashboard';
const AdminPrivateRoute = ({ children }) => {
  return isAdminLoggedIn() ? (
    <Dashboard children={children} />
  ) : (
    <Navigate to={routes.admin.login} />
  );
};

export default AdminPrivateRoute;
